/*
 * Copyright (c) 2025 Amazon.com, Inc. or its affiliates. All rights reserved.
 *
 * PROPRIETARY/CONFIDENTIAL. USE IS SUBJECT TO LICENSE TERMS.
 */

import {KatIcon} from '@amzn/katal-react';
import {useBundle} from '@amzn/react-arb-tools';
import {HOMEPAGE_MESSAGE_BUNDLE_NAME} from 'src/constants';
import {t} from 'src/helpers';
import {Screen} from 'src/theming/components/Screen';
import * as styles from './styles/SubmissionSuccessScreen.module.scss';
import {Button} from 'src/theming/components/Button';
import {usePhotoFormController} from 'src/photoForm/PhotoFormController';

export const SubmissionSuccessScreen = () => {
  const [bundle] = useBundle(HOMEPAGE_MESSAGE_BUNDLE_NAME);
  const {reset, lastSubmissionResult} = usePhotoFormController();

  return (
    <Screen className={styles.container}>
      {/* div for spacing */}
      <div />
      <KatIcon name="check_circle" />
      <h4>{t(bundle, 'submission_success_title')}</h4>
      <p className={styles.description}>
        {t(bundle, 'submission_success_description')}
      </p>
      {!(lastSubmissionResult instanceof Error) &&
        lastSubmissionResult !== null && (
          <p className={styles.description}>
            {t(bundle, 'submission_success_collection_count', {
              collectionCount: lastSubmissionResult.collectionCount,
            })}
          </p>
        )}
      <Button
        className={styles.retryButton}
        label={t(bundle, 'restart_form_button_label')}
        fullWidth
        onClick={() => {
          reset();
        }}
      />
    </Screen>
  );
};
